import { render } from "../templates/edit-question-actions.html?vue&type=template&id=ad82c92c"
import script from "./edit-question-actions.vue?vue&type=script&lang=js"
export * from "./edit-question-actions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__